var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CtkDateTimePicker',{attrs:{"format":"YYYY-MM-DD HH:mm","formatted":"DD MMM YYYY HH:mm","label":_vm.label,"locale":_vm.locale},on:{"input":function($event){return _vm.$emit('update:value', $event)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }